export default function isExtendedProfile({ document }) {
    return !!document.querySelector('div[class=extended-profile-job]');
}
